import { SectionTitleBarSwitch } from 'components/SectionTitleBarComponents/SectionTitleBarSwitch'
import { translate } from 'i18n/i18n'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'

export const SoilAverageDepthsToggle = () => {
  const { showSelectedSoilDepths } = detailsPanelStore.useSelector((s) => ({
    showSelectedSoilDepths: s?.showSelectedSoilDepths,
  }))

  return (
    <SectionTitleBarSwitch
      checked={showSelectedSoilDepths}
      onChange={(event) => {
        detailsPanelStore.setState((s) => ({ ...s, showSelectedSoilDepths: event.target.checked }))
      }}
      label={<span css={{ fontWeight: 'normal' }}>{translate.phrases.banyanApp('All Depths')}</span>}
    ></SectionTitleBarSwitch>
  )
}
